/*!
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';
import Svg from "../../widgets/Svg/Svg";
import moment from 'moment';
import {COURSE_DETAILS} from "../../constants/constants";

export default class CourseDetailsHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false
        };
    }
    render() {
        return (
            <div className={this.state.isVisible ? 'is-visible' : null}>
                <Collapsible
                    trigger={
                        <div className="course-header">
                            <span
                                role="button"
                                aria-expanded={this.state.isVisible}
                            >
                                {`${COURSE_DETAILS.COURSE_TITLE} ${this.props.courseSectionDetails.sectionTitle}`}
                            </span>
                            <span className="details-span">{`${COURSE_DETAILS.COURSE_NUMBER} ${this.props.courseSectionDetails.sectionCode}`}</span>
                            <span className="details-span">{`${COURSE_DETAILS.COURSE_COPY_CODE} ${this.props.courseSectionDetails.sectionCopyCode}`}</span>
                            <span className="details-span">{`${COURSE_DETAILS.STUDENT_INVITE_LINK} ${this.props.courseSectionDetails.inviteLink}`}</span>
                            <span className="details-span">{`${COURSE_DETAILS.COURSE_END_DATE} ${moment.utc(this.props.courseSectionDetails.endDate).format('YYYY-MM-DD')}`}</span>
                        </div>
                    }
                    overflowWhenOpen="visible"
                    tabIndex={0}
                    triggerSibling={() => <span><Svg svgString="bi-chevron-down" /></span>}
                    onOpening={() => this.setState({ isVisible: true })}
                    onClose={() => this.setState({ isVisible: false })}
                >
                    <div>{this.props.children}</div>
                </Collapsible>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/CourseDetailsHeader.js